import { initSlider } from './splidecust';

const partnerSplides = document.querySelectorAll(
  '.partner__splide, .getstart__splide'
);
partnerSplides?.forEach(container => {
  const splide = initSlider(container, {
    type: 'loop',
    gap: '1rem',
    loop: true,
    perPage: 1,
    autoplay: true,
    interval: 4000,
    pauseOnHover: true,
    drag: false, // Отключаем перетаскивание слайда мышью
    swipe: false, // Отключаем свайпы на мобильных устройствах
    keyboard: false, // Отключаем управление стрелками клавиатуры
    wheel: false, // Отключаем прокрутку колесом мыши
  });

  const arrowsPrev = container.querySelector('.arrows__prev');
  const arrowsNext = container.querySelector('.arrows__next');
  const arrowLoader = container.querySelector('.arrow-loader');

  const resetLoader = () => {
    arrowLoader.classList.remove('is-running');
    arrowLoader.querySelectorAll('span').forEach(span => {
      span.style.animation = 'none';
      void span.offsetWidth;
      span.style.animation = '';
    });
  };
  const startLoader = () => {
    resetLoader();
    arrowLoader.classList.add('is-running');
  };

  if (arrowLoader) {
    arrowLoader.classList.add('is-running');
    splide.on('autoplay:play', () => arrowLoader.classList.add('is-running'));
    splide.on('autoplay:pause', resetLoader);

    arrowsPrev.addEventListener('click', () => {
      startLoader();
    });
    arrowsNext.addEventListener('click', () => {
      startLoader();
    });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      splide.Components.Autoplay.pause();
    } else {
      splide.Components.Autoplay.play();
    }
  });
});
